import React, { Suspense } from 'react';
import { GlobalCallAlert } from '@features/calls/components/GlobalCallAlert';
import { TelnyxRemoteAudio } from '@features/calls/lib/telnyxWebRtcClient';
import { useAuthStore } from '@shared/stores/auth-store';
import { isCallStaffRole, setV2Live, useCallEngineStore, useResolveCallEngine } from './engine';

const CallsV2Shell = React.lazy(() => import('@features/calls-v2/CallsV2Shell'));

/** What the app shell mounts: the old call UI, or the new dock. */
export function CallsShellOverlay() {
  const role = useAuthStore(state => state.user?.role);
  const isCallStaff = isCallStaffRole(role);
  useResolveCallEngine(isCallStaff);
  const engine = useCallEngineStore(state => state.engine);

  if (isCallStaff && engine === 'v2')
    return (
      <Suspense fallback={null}>
        <CallsV2Shell onLiveChange={setV2Live} />
      </Suspense>
    );
  // Staff on a browser that has never asked: wait for the server's answer (4 s at most)
  // rather than start the old phone client and then tear it down again.
  if (isCallStaff && engine === null) return null;
  return (
    <>
      <TelnyxRemoteAudio />
      <GlobalCallAlert />
    </>
  );
}
